import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import moment from 'moment';
import { 
  SECTION_LIST,
  SECTION_SEARCH_ASSESSMENT_LIST,
  SECTION_ADD,
  SECTION_DETAIL,
  SECTION_UPDATE,
  SECTION_UPLOAD_SET
} from '../../actions';
import {
  SectionListSuccess,
  SectionListError,
  SectionSearchAssessmentListSuccess,
  SectionSearchAssessmentListError,
  SectionAddSuccess,
  SectionAddError,
  SectionDetailSuccess,
  SectionDetailError,
  SectionUpdateSuccess,
  SectionUpdateError,
  SectionUploadSetSuccess,
  SectionUploadSetError
} from '../../actions';
 
export function* watchSectionList() {
  yield takeEvery(SECTION_LIST, onSectionList);
}

export function* watchSectionSearchAssessmentList() {
  yield takeEvery(SECTION_SEARCH_ASSESSMENT_LIST, onSectionSearchAssessmentList);
}

export function* watchSectionAdd() {
  yield takeEvery(SECTION_ADD, onSectionAdd);
}

export function* watchSectionDetail() {
  yield takeEvery(SECTION_DETAIL, onSectionDetail);
}

export function* watchSectionUpdate() {
  yield takeEvery(SECTION_UPDATE, onSectionUpdate);
}

export function* watchSectionUpload() {
  yield takeEvery(SECTION_UPLOAD_SET, onSectionUpload);
}

const onSectionListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'section/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onSectionUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'section/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onSectionSearchAssessmentListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/assessment', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSectionAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'section/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onSectionDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'section/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onSectionUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/section/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_documents/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_documents/'});
      });
    });
  });
};


function* onSectionList(data) {
  try {
    const response = yield call(onSectionListAsync, data.payload);
    yield put(SectionListSuccess(response.data));
  } catch (error) {
    yield put(SectionListError(error));
  }
}

function* onSectionSearchAssessmentList(data) {
  try {
    const response = yield call(onSectionSearchAssessmentListAsync, data.payload);
    yield put(SectionSearchAssessmentListSuccess(response.data));
  } catch (error) {
    yield put(SectionSearchAssessmentListError(error));
  }
}

function* onSectionAdd(data) {
  try {
      const response = yield call(onSectionAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(SectionAddSuccess(response.data));
  } catch (error) {
      yield put(SectionAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onSectionDetail(data) {
  try {
    const response = yield call(onSectionDetailAsync, data.payload);
    yield put(SectionDetailSuccess(response.data.data));
  } catch (error) {
    yield put(SectionDetailError(error));
  }
}

function* onSectionUpdate(data) {
  try {
      const response = yield call(onSectionUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(SectionUpdateSuccess(response.data));
  } catch (error) {
      yield put(SectionUpdateError(error));
  }
}

function* onSectionUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onSectionUploadAsync, file);
    if(response.message ==='success'){
      yield put(SectionUploadSetSuccess(response));
    }
    else{
      yield put(SectionUploadSetError(response));
    }
  } catch (error) {
    yield put(SectionUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchSectionList),
    fork(watchSectionSearchAssessmentList),
    fork(watchSectionAdd),
    fork(watchSectionDetail),
    fork(watchSectionUpdate),
    fork(watchSectionUpload),
  ]);
} 